import { render, staticRenderFns } from "./DashboardCompanyBoard.vue?vue&type=template&id=5b030b5c&scoped=true"
import script from "./DashboardCompanyBoard.vue?vue&type=script&lang=js"
export * from "./DashboardCompanyBoard.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompanyBoard.vue?vue&type=style&index=0&id=5b030b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b030b5c",
  null
  
)

export default component.exports